import { motion } from 'framer-motion';

export default function Testimonials() {
  const testimonials = [
    {
      stars: 5,
      headline: 'Projeto excepcional e acompanhamento impecável',
      review: 'O Criarquitetura desenvolveu nossa casa de praia em Ilhabela com atenção a cada detalhe. O projeto aproveitou perfeitamente a vista para o mar e a ventilação natural. O acompanhamento de obra foi fundamental para garantir a qualidade da execução.',
      author: 'Roberto Mendes',
      role: 'Proprietário - Residência Praia do Sino',
      avatar: 'https://i.pravatar.cc/150?img=12'
    },
    {
      stars: 5,
      headline: 'Arquitetura que valoriza o terreno',
      review: 'Nosso terreno tinha muitos desafios por ser em declive. A equipe do Criarquitetura transformou isso em vantagem, criando uma casa com múltiplos níveis que aproveitam a topografia e proporcionam vistas incríveis de todos os ambientes.',
      author: 'Mariana Costa',
      role: 'Proprietária - Casa Ponta das Canas',
      avatar: 'https://i.pravatar.cc/150?img=45'
    },
    {
      stars: 5,
      headline: 'Profissionalismo e resultado surpreendente',
      review: 'Desde a primeira reunião até a entrega da obra, o processo foi transparente e organizado. O projeto ficou exatamente como imaginávamos, com uma arquitetura contemporânea que se integra perfeitamente à paisagem de Ilhabela.',
      author: 'Carlos Ferreira',
      role: 'Proprietário - Residência Curral',
      avatar: 'https://i.pravatar.cc/150?img=33'
    },
    {
      stars: 5,
      headline: 'Expertise em arquitetura litorânea',
      review: 'A experiência do estúdio em projetos litorâneos fez toda diferença. Escolheram materiais adequados para resistir à maresia e criaram soluções inteligentes de ventilação que mantêm a casa fresca naturalmente.',
      author: 'Ana Paula Silva',
      role: 'Proprietária - Casa Barra Velha',
      avatar: 'https://i.pravatar.cc/150?img=28'
    },
    {
      stars: 5,
      headline: 'Atenção aos detalhes e prazos',
      review: 'O que mais nos impressionou foi a atenção aos detalhes em todas as etapas. O projeto foi entregue no prazo e o acompanhamento de obra garantiu que tudo fosse executado conforme planejado. Recomendamos muito!',
      author: 'Eduardo Santos',
      role: 'Proprietário - Residência Perequê',
      avatar: 'https://i.pravatar.cc/150?img=51'
    },
    {
      stars: 5,
      headline: 'Casa dos sonhos em Ilhabela',
      review: 'Realizamos o sonho de ter uma casa de praia em Ilhabela com a ajuda do Criarquitetura. O projeto superou nossas expectativas, criando espaços amplos e integrados que valorizam a convivência familiar e a paisagem.',
      author: 'Juliana Oliveira',
      role: 'Proprietária - Casa Veloso',
      avatar: 'https://i.pravatar.cc/150?img=20'
    }
  ];

  return (
    <section className="bg-[#FAF8F5] py-16 sm:py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-12 sm:mb-16"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-2 h-2 bg-accent rounded-full"></div>
            <span className="font-inter text-sm text-gray-600">Depoimentos</span>
          </div>
          <h2 className="font-inter font-bold text-3xl sm:text-4xl lg:text-6xl text-gray-900 mb-3 leading-tight">
            O que nossos<br />clientes dizem
          </h2>
          <p className="font-inter text-sm sm:text-base text-gray-600">
            Projetos entregues em Ilhabela e região
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              className="bg-white rounded-2xl p-6 sm:p-8 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex gap-1 mb-4 sm:mb-6">
                {[...Array(testimonial.stars)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent text-lg sm:text-xl"></i>
                ))}
              </div>
              <h3 className="font-inter font-semibold text-base sm:text-lg text-gray-900 mb-3 sm:mb-4">
                {testimonial.headline}
              </h3>
              <p className="font-inter text-sm text-gray-700 leading-relaxed mb-4 sm:mb-6">
                {testimonial.review}
              </p>
              <div className="flex items-center gap-3 sm:gap-4 pt-4 border-t border-gray-100">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.author}
                  className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover"
                />
                <div>
                  <p className="font-inter font-bold text-sm text-gray-900">
                    {testimonial.author}
                  </p>
                  <p className="font-inter text-xs text-gray-600">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
